import { SVGProps } from "react";

export default function ClockHistoryIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 16, width = 16, stroke = "#545454", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10.47 10.1199L8.40333 8.88659C8.04333 8.67326 7.75 8.15992 7.75 7.73992V5.00659"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66927 3.99992C1.83594 5.11325 1.33594 6.49992 1.33594 7.99992C1.33594 11.6799 4.3226 14.6666 8.0026 14.6666C11.6826 14.6666 14.6693 11.6799 14.6693 7.99992C14.6693 4.31992 11.6826 1.33325 8.0026 1.33325C7.04927 1.33325 6.13594 1.53325 5.31594 1.89992"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
